import { ReactElement } from 'react';
import { IErrorProps } from '@components/common';

export const ErrorResponse = (props: IErrorProps): ReactElement => {
	const { errorMessage } = props;

	return <div className="error-message-main">An error has occurred : {errorMessage}</div>;
};
